

const Loader = () => {
  return (
    <div className="loadingContainer">
      <div className="loader" alt="Loading report..." />
    </div>
  );
}

export default Loader;